import { globals, utilities } from "../../styles";

function NextLineupButtons(props: {
  hasLineupChanged: boolean;
  canConfirmLineup: boolean;
  handleSearchOpened: () => void;
  handleCancelNewLineupClicked: () => void;
  handleConfirmNewLineupClicked: () => void;
}) {
  const {
    hasLineupChanged,
    canConfirmLineup,
    handleCancelNewLineupClicked,
    handleConfirmNewLineupClicked,
  } = props;
  return (
    <div
      className={`${utilities["flex-row"]}`}
      style={{ marginBottom: "50px", gap: "4px" }}
    >
      <button
        className={globals["button-wrapper"]}
        onClick={handleCancelNewLineupClicked}
        disabled={!hasLineupChanged}
      >
        <div className={globals["sml-icon-btn"]}>Reset Lineup</div>
      </button>
      <button
        className={globals["button-wrapper"]}
        onClick={handleConfirmNewLineupClicked}
        disabled={!(hasLineupChanged && canConfirmLineup)}
      >
        <div className={globals["sml-icon-btn"]}>Confirm New Lineup</div>
      </button>
    </div>
  );
}

export default NextLineupButtons;
